import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { getTypeAlias } from "../../../model/device";

export function AutoProbedCard({ device, success, handleOpen }) {
  const theme = useTheme();

  function AutoProbeStatus({ success }) {
    if (success) return <CheckCircleIcon sx={{ alignSelf: "center" }} color="success" />;
    return <ErrorIcon sx={{ alignSelf: "center" }} color="error" />;
  }

  return (
    <Box
      onClick={handleOpen}
      display="flex"
      justifyContent="space-between"
      width="100%"
      sx={{
        borderRadius: 3,
        mb: 1,
        border: (theme) => "1px solid " + theme.palette.background.border,
        padding: 2,
        backgroundColor: "white",
        "&:hover": { backgroundColor: "#EEE" },
        cursor: "pointer",
      }}
    >
      <Stack>
        <Typography variant="body">
          <b>{device.device_class ? device.device_class?.toUpperCase() : "UNKNOWN"}</b>
        </Typography>
        <Typography variant="body" style={{ paddingBottom: 10 }}>
          <b style={{ color: theme.palette.primary.main }}>
            {getTypeAlias(device.device_type ? device.device_type : "Unknown")}
          </b>
          <b style={{ color: "lightgrey" }}> • </b>
          <b style={{ color: theme.palette.secondary.main }}>{device.address}</b>
        </Typography>
      </Stack>
      <AutoProbeStatus success={success} />
    </Box>
  );
}
